import React from 'react';
import './Footer.css';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const Footer = () =>(
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-section company-info">
          <div className="footer-logo-row">
            <img src="/images/pelican_logo.png" alt="Pelican Infotech" className="footer-logo" />
            <h3>Pelican Infotech</h3>
          </div>
          <p>Empowering your digital journey with innovative IT solutions.</p>
        </div>
        <div className="footer-section quick-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/AboutUs">About Us</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer-section contact-info">
          <h4>Contact</h4>
          <p>Email: <a href="mailto:info@pelicaninfotech.com">info@pelicaninfotech.com</a></p>
          <p>Phone: <a href="tel:+919663384126">+91 96633 84126</a></p>
          <p>Location:  No 351, 1st Floor, Bannerghatta Rd, opposite to PAI International,
            Sundar Ram Shetty Nagar, Bilekahalli, Bengaluru, Karnataka 560076</p>
        </div>
        <div className="footer-section social-media">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="icon-animate"><FaFacebookF /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="icon-animate"><FaTwitter /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="icon-animate"><FaLinkedinIn /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="icon-animate"><FaInstagram /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} PelicanInfotech. All rights reserved.</p>
      </div>
    </footer>
);

export default Footer;